import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

// Material UI
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import MenuItem from '@material-ui/core/MenuItem';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

// Custom Inputs
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import TextInput from './inputs/TextInput'
import FormSelect from './inputs/FormSelect'
import MultiSelect from './inputs/MultiSelect'

// Custom Views
import CustomDialog from './inputs/CustomDialog'
import InnerBar from './InnerBar';
import MetaBox from './inputs/MetaBox'
import TemplatePreview from './TemplatePreview'
import QuestionPreview from './QuestionPreview'
import LevelSubForm from './LevelSubForm'
import CompetencySubForm from './CompetencySubForm'

import {
  is_logged_on,
  is_validating,
  theme
 } from "../helpers"

import {
  LocalForm,
  Control,
  actions,
  track
} from 'react-redux-form'

import {
  isRequired,
  isNumeric
} from "../validators"

import {
  businesses_select,
  get_template,
  create_template,
  update_template,
  reset_template,
  trash_template,
  preferences_index,
  questions_xlsx,
  clear_template,
  get_pool_data
} from '../actions'

const localstyles = {
  toolbar: theme.mixins.toolbar,
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
  listItems: {
    paddingTop: '20px',
    paddingBottom: '20px',
  },
  iconbutton: {
    disabled: {
      background: 'none'
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getTemplate: template_id => dispatch( get_template(template_id) ),
    getBusinesses: () => dispatch( businesses_select() ),
    createTemplate: values => dispatch( create_template(values) ),
    updateTemplate: (template_id, values) => dispatch( update_template(template_id, values) ),
    getPreferences: () => dispatch( preferences_index() ),
    resetTemplate: () => dispatch( reset_template() ),
    clearTemplate: () => dispatch( clear_template() ),
    trashTemplate: (id) => dispatch( trash_template(id) ),
    questionsXLSX: (filters) => dispatch ( questions_xlsx(filters) ),
    getPoolData: (skill_id, tags=[]) => dispatch( get_pool_data(skill_id, tags))
  };
};

const mapStateToProps = (state) => {

  return {
    current_user: state.auth.current_user.data,
    template: state.template.template,
    fetching: state.template.fetching_single,
    errors: state.template.errors,
    mustRedirect: state.template.must_redirect,
    setStatus: state.template.set_status,
    skills: state.skill.items,
    skillErrors: state.skill.errors,
    levels: state.preference.levels,
    competencies: state.competency.items,
    tags: state.tag.items,
    businesses: state.business.select_items,
    preferences: {
      template_questions: state.preference.preferences.template_questions,
      template_minutes: state.preference.preferences.template_minutes,
    },
    pool: state.question.levels_per_tag_and_skill
  };
}

class ConnectedTemplateForm extends React.Component {
  constructor() {
    super()
    this.state = {
      loaded: false,
      needsReset: false,
      formValid: false,
      formPristine: true,
      nameValid: true,
      numberValid: true,
      minutesValid: true,
      skill: '',
      showDialog: false,
      showPreview: false,
      showQuestionPreview: false,
      version: null,
      publish: false,
      trash: false,
      versionsOpen: false,
      formData: null,
      staticPreview: null,
      skillValid: true,

      // Many to many
      tags: [],
      businesses: [],

      localCompetencies: [],

      levelErrors: { A1: {}, A2: {}, B1: {}, B2: {}, C1: {}, C2: {} }
    }

  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  handleTags = value => {
    console.log(value)
    this.renewPool(null, value)
    this.setState({tags: value})
  }

  handleBusinesses = value => {
    this.setState({businesses: value})
  }

  handleSubmit(inValues) {
    let values = {
      ...inValues,
      competencies: this.state.localCompetencies.map( c => {
        return {id: c.id, name: c.name, ratio: c.ratio}
      }),
      tag_ids: this.state.tags.map( tag => tag.value ),
      business_ids: this.state.businesses.map( business => business.value ),
    }
    if (this.state.publish) {
      values={
        ...values,
        publish: true,
        index: false
      }
    }

    if ( this.checkValid(false)) {
      if (this.state.actionName === "create") {
        this.props.createTemplate(values)
      } else if (this.state.actionName !== "create"){
        const { template_id } = this.props.match.params
        this.props.updateTemplate(template_id, values)
      }
    }

  }

  handleUpdate(form) {
    const { name, number_questions, minutes, levels, $form } = form
    this.setState({formData: form})

    const nameValid = (name.pristine || name.valid)
    const numberValid = (number_questions.pristine || number_questions.valid)
    const minutesValid = (minutes.pristine || minutes.valid)

    let skillValid = (this.state.skill !== '')
    const formValid = $form.valid && skillValid

    let levelErrors = {}
    Object.keys(levels).forEach( (key) => {
      if ( key === "$form") {
        return
      }
      const {name, score_right, score_wrong, level_up, level_down, min_average, msr} = levels[key]
      const level = {score_right, score_wrong, level_up, level_down, min_average, msr}
      levelErrors[name.value] = {
        score_right: !level.score_right.valid,
        score_wrong: !level.score_wrong.valid,
        level_up: !level.level_up.valid,
        level_down: !level.level_down.valid,
        min_average: !level.min_average.valid,
        msr: !level.msr.valid,
      }
    })

    this.setState({
      nameValid: nameValid,
      numberValid: numberValid,
      minutesValid: minutesValid,
      formPristine: form.pristine,
      levelErrors: levelErrors,
      formValid: formValid
    })

  }

  componentWillMount() {
    const actionName = this.props.match.path === '/templates/new' ? 'create' : 'update'

    this.setState({
      actionName: actionName
    })

    if ( actionName === "create") {
      this.props.clearTemplate()
    } else {
      this.props.resetTemplate()
    }

    if (actionName !== "create") {
      const {template_id} = this.props.match.params
      if ( this.props.template.id !== template_id ) {
        this.props.getTemplate(template_id)
      }
    }
    this.props.getBusinesses()
    this.props.getPreferences()

    // if (this.props.actionName === 'create') {
    //   const {template_questions, template_right, template_wrong} = this.props.preferences
    //   if (!template_questions || !template_right || !template_wrong ) {
    //   }
    // }
  }
  //
  // componentWillUnmount() {
  //   this.props.clearTemplate()
  // }

  componentDidUpdate(prevProps, prevState ) {
    const actionName = this.props.match.path === '/templates/new' ? 'create' : 'update'
    if (actionName !== this.state.actionName) {
      return this.setState({ actionName: actionName })
    }
    if (prevState.actionName === 'update' && this.state.actionName === 'create') {
      this.props.clearTemplate()
      return this.setState({
        needsReset: true,
        levelErrors: { A1: {}, A2: {}, B1: {}, B2: {}, C1: {}, C2: {} },
        skill: '',
        businesses: [],
        tags: []
      })
    }
    if (this.state.needsReset) {
      return this.setState({ needsReset: false})
    }

    const { template } = this.props

    if ( !this.state.loaded && template && this.state.tags.length === 0 && template.tags !== undefined && template.tags.length > 0 ) {
      this.setState({
        tags: template.tags
      })
    }
    if ( !this.state.loaded && template && this.state.businesses.length === 0 && template.businesses !== undefined && template.businesses.length > 0 ) {
      this.setState({
        businesses: template.businesses
      })
    }
    if (prevProps.template.id !== template.id) {
      this.setState({loaded: true})
    }
    if (actionName === "update" && template.competencies && this.state.localCompetencies.length !== template.competencies.length) {
      this.setState({
        localCompetencies: template.competencies.map( c=> {
          return {
            id: c.id,
            name: c.name,
            ratio: c.ratio,
            invalid: false
          }
        })
      })
    } else if (actionName === "create" && this.state.localCompetencies.length !== this.props.competencies.length) {
      this.setState({
        localCompetencies: this.props.competencies.map( c=> {
          return {
            id: c.id,
            name: c.name,
            ratio: c.ratio,
            invalid: false
          }
        })
      })
    }

    if (actionName === 'create') {
      if (!prevProps.preferences.template_questions && this.props.preferences.template_questions) {
        this.formDispatch( actions.change('template.number_questions', this.props.preferences.template_questions) )
        this.formDispatch( actions.change('template.minutes', this.props.preferences.template_minutes) )
        this.formDispatch( actions.merge('template.levels', this.props.levels) )
      }
    } else {
      if ( this.state.skill === '' && template.skill && template.skill !== '' ) {
        this.setState({skill: template.skill.id })
        this.props.getPoolData(template.skill.id, template.tags.map( tt => tt.value ))
      }

      const {template_id} = this.props.match.params
      if (prevProps.template.id !== undefined && !this.props.fetching && prevProps.template.id !== template_id) {
        this.props.getTemplate(template_id)
      }
    }
    if (this.props.mustRedirect && !prevProps.mustRedirect && !this.state.publish) {
      window.showSnackbar('success', 'Template has been saved.')
    }
  }

  handleCompetency(e, id) {
    // const isValid = e.target.value && e.target.value.length > 0 && this.state.localCompetencies.filter( c => c.name === e.target.value && c.id !== id).length === 0
    const newCompetencies = this.state.localCompetencies.map( competency =>{
      const newRatio = e.target.value
      if (competency.id === id) {
        return {
          ...competency,
          ratio: isNumeric(newRatio, true) ? parseInt(newRatio, 10) : '',
          invalid: !isNumeric(newRatio, true), // allowZero
        }
      }
      return {
        ...competency
      }
    })

    this.setState({
      localCompetencies: newCompetencies,
    })
  }

  renewPool(newSkill, newTags) {
    const {skill, tags} = this.state
    const theSkill = newSkill || skill
    const theTags = newTags || tags
    const tag_ids = theTags.map( t => t.value )
    this.props.getPoolData(theSkill, tag_ids)
  }

  handleChange(e) {
    const { value } = e.target
    this.formDispatch(actions.change('template.skill', value))
    this.setState({skill: value, skillValid: ( value && value !== '' )})
    this.renewPool(value, null)
  }

  handleTrash() {
    const {template_id} = this.props.match.params
    this.setState({trash: true, showDialog: false})
    this.props.trashTemplate(template_id)
  }

  hideDialog() {
    this.setState({showDialog: false, showPreview: false, showQuestionPreview: false, version: {}, staticTemplate: {}})
  }

  handlePublish() {
    this.props.resetTemplate()
    this.setState({publish: true, showDialog: false})
    this.formDispatch(actions.submit('template'))
  }

  handleXLSX() {
    const skill_id = (this.state.skill && this.state.skill !== null) ? this.state.skill : (this.props.template.skill ? this.props.template.skill.id : '')
    this.props.questionsXLSX({skill: skill_id, active: true, trash: false})
  }

  // skillData() {
  //   const skill_id = (this.state.skill && this.state.skill !== null) ? this.state.skill : this.state.actionName !== "create" ? this.props.template.skill.id : null
  //   const skill = this.props.skills.find( s => s.id === skill_id )
  //   if (!skill) {
  //     return {}
  //   }
  //   const {total, ...levels} = skill.questions
  //   return {
  //     available_questions: total,
  //     levels: {
  //       ...levels
  //     },
  //     id: skill.id
  //   }
  // }

  handleQuestionsPreview() {
    this.setState({ showQuestionPreview: true })
  }

  openVersions() {
    this.setState({ versionsOpen: !this.state.versionsOpen})
  }

  templatePreview() {
    let setObject = {}
    if (this.state.formData === null) {
      setObject={
        skill: this.props.template.skill ? this.props.template.skill.name : '',
        competencies: this.props.template.competencies || [],
        tags: this.props.template.tags,
        businesses: this.props.template.businesses,
        name: this.props.template.name,
        number_questions: this.props.template.number_questions,
        minutes: this.props.template.minutes,
        levels: this.props.template.levels,
        modifier: this.props.template.modifier,
        updated_at: this.props.template.updated_at,
        creator: this.props.template.creator,
        created_at: this.props.template.created_at,
        id: this.props.template.id
      }
    } else {
      const { name, number_questions, minutes, skill, levels } = this.state.formData
      const { skills } = this.props
      setObject={
        static: true,
        skill: (skill.value && skill.value !== '') ? skills.find( sk => sk.id === skill.value).name : this.props.template.skill.name,
        tags: this.state.tags,
        businesses: this.state.businesses,
        competencies: this.state.localCompetencies.map(c=> {
          return {
            id: c.id, name: c.name, ratio: c.ratio
          }
        }),
        name: name.value,
        number_questions: number_questions.value,
        minutes: minutes.value,
        creator: this.props.template.creator,
        levels: Object.keys(levels).filter( key => key !== '$form' ).map( key => {
          const {name, questions, score_right, score_wrong, level_up, level_down, min_average, msr} = levels[key]
          return {
            name: name.value,
            score_right: score_right.value,
            score_wrong: score_wrong.value,
            level_up: level_up.value,
            level_down: level_down.value,
            min_average: min_average.value,
            msr: msr.value,
            questions: questions.value
          }
        }),
        created_at: this.props.template.created_at,
        id: this.props.template.id
      }
    }
    this.setState({showPreview: true, version: null, staticTemplate: setObject})
  }

  checkValid(showAlert = true) {
    this.formDispatch( actions.setDirty('template.name') )
    this.formDispatch( actions.setDirty('template.number_questions') )
    this.formDispatch( actions.setDirty('template.minutes') )
    let skillValid = true
    if (this.state.skill === '') {
      skillValid = false
      this.setState({skillValid: false})
    }
    const competenciesValid = this.state.localCompetencies.filter( c => c.invalid ).length === 0

    const isValid = this.state.formData.$form.valid && skillValid && competenciesValid
    if (!isValid && showAlert) {
      window.showSnackbar('error', 'Please fill in all mandatory fields.')
    }
    return isValid
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { current_user, skills } = this.props

    if ( current_user.role !== 'admin' ) {
      return <Redirect to="/" />
    }

    const { mustRedirect, setStatus, template, pool } = this.props
    const actionName = this.props.match.path === '/templates/new' ? 'create' : 'update'

    const {
      id, name, number_questions, minutes, levels,
      active, skill, creator, modifier, trash, versions, created_at, updated_at
    } = template

    // if (actionName !== "create" && (!template.name || this.props.fetching)) {
    if (this.state.needsReset) {
      return ''
    }

    if (actionName !== "create" && !template.name ) {
      return ''
    }
    if (actionName === 'create' && (this.props.levels === undefined || this.props.levels.length === 0) ) {
      return ''
    }

    if (this.props.template.fetching_single && (id === undefined || id === null || id === '')) {
      return ''
    }

    if (mustRedirect && this.state.publish) {
      return (
        <Redirect to="/templates" />
      )
    } else if ( mustRedirect && actionName === "create" && template.id ) {
      return (
        <Redirect to={`/templates/${template.id}/edit`} />
      )
    } else if (setStatus && this.state.trash) {
      return (
        <Redirect to="/templates" />
      )
    }

    let initialState
    if (actionName === "create") {
      initialState = {
        name: '',
        skill: '',
        number_questions: this.props.preferences.template_questions,
        minutes: this.props.preferences.template_minutes,
        levels:  this.props.levels
      }
    } else {
      initialState = {
        name: name,
        number_questions: number_questions,
        minutes: minutes,
        levels: levels,
        skill: skill,
      }
    }

    const actionButtons = (
      <div className="d-flex">
        <CustomOutlinedButton
          className="buttonnoto c-blue align-self-center mr-16"
          disabled={false && !this.state.formValid}
          onClick={e => {
            e.preventDefault()
            this.setState({publish: false, trash: false})
            this.checkValid()
            this.formDispatch( actions.submit('template'))
          }}>Save</CustomOutlinedButton>
      </div>
    )

    return (
      <MuiThemeProvider theme={theme}>

          <Grid container spacing={24} justify="space-between">

            <Grid item xs={12} md={ 8 } className="will-change9">

              <div className="d-flex justify-content-between mb-40">

                <Typography className="fw-bold h4">
                  Template
                </Typography>

                { actionButtons }

              </div>

            </Grid>

            <Grid item xs={12} md={ 8 } className="will-change9">

                <LocalForm
                  model="template"
                  className="collection-item"
                  initialState={initialState}
                  getDispatch={(dispatch) => this.attachDispatch(dispatch)}
                  onUpdate={(form) => this.handleUpdate(form)}
                  onSubmit = {(values) => this.handleSubmit(values)}
                >

                  <Paper use="name" className="mb-24 innerbar">
                    <InnerBar text="Test Template Name" />
                    <div className="pl-24 pr-24 pt-24 pb-24">
                      <TextInput
                        id="template-name"
                        model="template.name"
                        required
                        placeholder="Give a name to the Template"
                        helperText="Required Field*"
                        error={!this.state.nameValid}
                        validators={{
                          required: (val) => {
                            return isRequired(val)
                          }
                        }}
                      />
                    </div>
                  </Paper>

                  <Paper use="template" className="mb-24 innerbar">
                    <InnerBar text="Test Template Settings"/>
                    <div className="pl-24 pr-24 pt-24 pb-24">
                      <Grid item xs={12} md={12}>

                        <Grid container spacing={24}>
                          <Grid item xs={12} sm={6} lg={4} xl={3}>
                            <Typography className="h6 mb-12">Template Skill</Typography>

                            <Control.select
                              model="wah"
                              id="template-skill"
                              value={this.state.skill}
                              label="Select Skill *"
                              component={FormSelect}
                              required
                              error={!this.state.skillValid}
                              helperText={this.state.skillValid ? '' : 'Skill is required'}
                              className="body2 customFormControlSelect"
                              onChange={(e) => this.handleChange(e)}
                              validators={{
                                required: (val) => {
                                  return isRequired(val)
                                }
                              }}
                            >
                              {
                                skills.map( skill => {
                                  return <MenuItem key={skill.id} value={skill.id}>{skill.name}</MenuItem>
                                })
                              }
                            </Control.select>
                          </Grid>
                          <Grid item container xs={12} sm={6} lg={8} xl={5}>
                            <Grid item xs={12} lg={6}>
                            <Typography className="h6 mb-24">#Qs in Pool: {
                              pool.pool
                              // this.skillData().available_questions
                            }</Typography>
                            <div className="d-flex flex-wrap lang-difficulty">

                              { pool.levels &&
                                Object.keys(pool.levels).map( (n, index) => {

                                  return (
                                    <MetaBox
                                      key={index}
                                      index={index}
                                      title={n}
                                      value={pool.levels[n]}
                                    />
                                  )
                                })
                              }
                              </div>
                              </Grid>
                           </Grid>
                        </Grid>

                        <div className="template-inputs-wrapper">
                        <Typography className="h6 mt-20 mb-12">Scoring</Typography>
                        { this.props.levels && this.props.levels.length > 0 &&
                          this.props.levels.map(level => {

                            return (
                              <LevelSubForm numOfCols={12} key={`level-${level.name}`} levelname={level.name} track={track} parentstate={this.state.levelErrors[level.name]} base="template"/>

                            )
                          })
                        }
                        </div>
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <Typography className="h6 mt-32 mb-12">Competency Occurence</Typography>
                        {
                          this.state.localCompetencies.length > 0 && this.state.localCompetencies.map(competency => {
                            return (
                              <CompetencySubForm
                                numOfCols={6}
                                key={`competency-${competency.id}`}
                                competency={competency}
                                base="template"
                                totalRatio={this.state.localCompetencies.map(a=>a.ratio).reduce((a,b)=>parseInt(a,10)+parseInt(b,10))}
                                handleCompetency={this.handleCompetency.bind(this)}
                              />
                            )
                          })
                        }
                      </Grid>

                      <Grid item xs={12} md={4}>

                        <Typography className="h6 mt-32 mb-12">Number of Questions</Typography>
                        <TextInput
                          id="template-number_questions"
                          model="template.number_questions"
                          required
                          error={!this.state.numberValid}
                          helperText="Number of questions to be served"
                          validators={{
                            required: val=> isNumeric(val)
                          }}
                        />

                        <Typography className="h6 mt-32 mb-12">Test Time Limit</Typography>
                        <TextInput
                          id="template-minutes"
                          model="template.minutes"
                          required
                          error={!this.state.minutesValid}
                          helperText="Test Time Limit in Minutes"
                          validators={{
                            required: val=> isNumeric(val)
                          }}
                        />

                      </Grid>
                    </div>
                  </Paper>

                </LocalForm>

                <Hidden smDown>
                  <div className="d-flex justify-content-end mt-40">
                    { actionButtons }
                  </div>
                </Hidden>

            </Grid>

            <Grid item xs={12} md={4} className="will-change3">
              <Paper>
              {
                actionName !== "create" && (
                  <React.Fragment>
                    <div className="bg-white">
                      <div className="pt-24 pb-24 pr-24 pl-24">
                        <div className="mb-12 c-black087 body2">
                          <span className="d-inline-block fw-bold min-width-100">Status:</span>{active ? 'Published ' : trash ? "In Trash " : "Draft "}
                        </div>

                        <MetaBox
                          title="Created by"
                          value={creator.display_name}
                        />
                        <MetaBox
                          title="Created on"
                          value={new Date(created_at).toLocaleString()}
                        />
                        <MetaBox
                          title="Modified by"
                          value={(modifier && modifier.display_name) || creator.display_name}
                        />
                        <MetaBox
                          title="Modified on"
                          value={new Date(updated_at).toLocaleString()}
                        />
                        <MetaBox
                          title="ID"
                          value={id}
                        />

                      </div>
                    </div>

                    <Divider className="bg-divider" />
                    <div className="bg-white">
                      <div className="pt-24 pb-24 pr-24 pl-24">
                      <div className="fw-bold body2">Actions:</div>
                        {
                            !active && !trash && (
                              <React.Fragment>

                                <Link className="c-black087 body2 d-block mb-8 mt-8" to='' onClick={e=> {
                                  e.preventDefault()
                                  this.templatePreview()
                                }}>Preview Template</Link>

                                <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=>{
                                    e.preventDefault()
                                    if (this.checkValid()) {
                                      this.setState({showDialog:true})
                                    }
                                }}>Publish Template</Link>

                                <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=> {
                                  e.preventDefault()
                                  this.handleTrash()
                                }}>Move to Trash</Link>

                                <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=> {
                                  e.preventDefault()
                                  this.handleXLSX()
                                }}>Download Questions (XLSX)</Link>

                                <Link className="c-black087 body2 d-block mb-8" to="" onClick={e=>{
                                  e.preventDefault()
                                  this.handleQuestionsPreview()
                                }}>
                                  Preview Questions ({pool.pool})
                                </Link>

                              </React.Fragment>
                            )
                          }

                      </div>
                    </div>
                    <Divider className="bg-divider" />
                  </React.Fragment>
                )}
                  <div use="businesses" className="tags-wrapper pt-24 pb-24 pr-24 pl-24">
                    <div className="fw-bold mb-8 body2">Assign to B2B:</div>
                    <MultiSelect
                      placeholder="Add businesses"
                      value={this.state.businesses}
                      handleChange={this.handleBusinesses.bind(this)}
                      helperText="Type or chose from menu"
                      suggestions={
                        this.props.businesses.map( business => {
                          return {
                            value: business.id,
                            label: business.name
                          }
                        })
                      }
                    />
                  </div>

                  <Divider className="bg-divider" />
                  <div use="tags" className="tags-wrapper pt-24 pb-24 pr-24 pl-24">
                    <div className="fw-bold mb-8 body2">Tags:</div>
                    <MultiSelect
                      placeholder="Add tags"
                      value={this.state.tags}
                      handleChange={this.handleTags.bind(this)}
                      helperText="Type or chose from menu"
                      suggestions={
                        this.props.tags.map( tag => {
                          return {
                            value: tag.id,
                            label: tag.name
                          }
                        })
                      }
                    />
                  </div>

                  <Divider className="bg-divider" />
                    {
                      actionName !== "create" && versions !== undefined && versions.length > 0 && (
                        <div>
                          <List className="sidebar-list" disablePadding={true}>
                            <ListItem
                              button
                              onClick={this.openVersions.bind(this)} style={localstyles.listItems}
                              className={this.state.versionsOpen ? "items is_current" : "items"}>
                              <ListItemText inset primary="Versions" className="spans" />
                              {this.state.versionsOpen ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse
                              in={this.state.versionsOpen}
                              timeout="auto"
                              unmountOnExit
                              >
                              <List disablePadding>
                                {
                                  versions.map(version => {
                                    return (
                                      <div key={version.id}>

                                        <ListItem className="pt-24 pb-32">
                                          <div>

                                            <MetaBox
                                              title="ID"
                                              value={version.shortid}
                                            />
                                            <MetaBox
                                              title="User"
                                              value={version.creator}
                                            />
                                            <MetaBox
                                              title="Published on"
                                              value={new Date(version.published_at).toLocaleString()}
                                            />
                                            <MetaBox
                                              title="Published by"
                                              value={version.publisher}
                                            />

                                            <div className="d-flex align-items-center">
                                              <Link className="c-black087 body2 t-decoration-underline mr-4" to='' onClick={e=>{
                                                  e.preventDefault()
                                                  this.setState({showPreview: true, version: version, staticTemplate: null})
                                                }}>Preview version
                                              </Link>
                                              <Icon style={{color: 'rgba(0,0,0,0.54)', fontSize: '16px'}}>remove_red_eye</Icon>
                                            </div>
                                          </div>
                                        </ListItem>
                                        <Divider className="bg-divider" />
                                      </div>
                                    )
                                  })
                                }
                              </List>
                            </Collapse>
                          </List>
                        </div>

                      )
                    }
                  </Paper>

                  <Hidden mdUp>
                    <div className="d-flex justify-content-end mt-40">
                      { actionButtons }
                    </div>
                  </Hidden>

                  <CustomDialog
                    id={`publish-dialog`}
                    qid={this.props.match.params.id}
                    fullScreen = {false}
                    isopen={this.state.showDialog}
                    handleClose={this.hideDialog.bind(this)}
                    handleAccept={this.handlePublish.bind(this)}
                    title={`Publish Template?`}
                  >
                    Do you want to save changes and publish this template?
                  </CustomDialog>

                </Grid>
              )
            }
            <QuestionPreview
              id="preview-dialog"
              isopen={this.state.showQuestionPreview}
              handleClose={this.hideDialog.bind(this)}
              preview={true}
              filters={{
                skill: (this.state.skill && this.state.skill !== null) ? this.state.skill : (this.props.template.skill ? this.props.template.skill.id : ''),
                tags: this.state.tags.map( tt => tt.value ),
                active: true,
                trash: false
              }}
            />
            <TemplatePreview
              id="preview-dialog"
              isopen={this.state.showPreview}
              version={this.state.version}
              template={this.state.staticTemplate}
              is_static={true}
              handleClose={this.hideDialog.bind(this)}
            />
          </Grid>

      </MuiThemeProvider>
    )
  }
}

const TemplateForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedTemplateForm);

export default TemplateForm



// WEBPACK FOOTER //
// ./src/js/components/TemplateForm.js